import React, { useEffect, useState } from "react";
import { Switch } from "../ui/switch";
import { toast } from "../ui/sonner";
import { MessageSquare } from "lucide-react";

/* 现场评估邀约 / 回复 / 提醒 → 员工短信开关 (默认开; 仅 admin 可改; 关闭后只发站内铃铛) */
export function SiteEvalSmsToggle({ api, zh }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/site-eval-invite-sms").then(({ data }) => setS(data)).catch(() => {}); }, [api]);
  const toggle = async (v) => {
    setBusy(true);
    try { const { data } = await api.put("/settings/site-eval-invite-sms", { enabled: v }); setS((p) => ({ ...p, ...data })); toast.success(zh ? `现场评估员工短信已${v ? "开启" : "关闭（仅铃铛）"}` : `Staff SMS ${v ? "on" : "off (bell only)"}`); }
    catch (e) { toast.error(e?.response?.data?.detail || (zh ? "保存失败" : "Save failed")); }
    setBusy(false);
  };
  if (!s) return null;
  const live = s.enabled && s.smsConfigured;
  return (
    <div className={`rounded-xl border px-4 py-2.5 text-xs flex items-center gap-3 flex-wrap ${live ? "border-amber-200 bg-amber-50 text-amber-900" : "border-slate-200 bg-slate-50 text-slate-600"}`} data-testid="site-eval-sms-toggle" data-on={s.enabled ? 1 : 0}>
      <MessageSquare className="h-3.5 w-3.5" />
      <span className="font-semibold">{zh ? "现场评估邀约 · 员工短信" : "Site-eval invite staff SMS"}</span>
      <span>{zh ? "邀约 / 改期重邀 → 被邀约同事；回复 → 发起人；前一天 / 前 1 小时提醒 → 已同意同事。" : "Invite → invitee; response → initiator; reminders → accepted colleagues."}</span>
      <b data-testid="site-eval-sms-state">{s.enabled ? (s.smsConfigured ? (zh ? "开（有手机号的员工会实发短信）" : "on (real SMS)") : (zh ? "开（短信服务未配置，实际仅铃铛）" : "on (SMS not configured)")) : (zh ? "关（仅站内铃铛）" : "off (bell only)")}</b>
      {s.canEdit ? <Switch data-testid="site-eval-sms-switch" checked={!!s.enabled} disabled={busy} onCheckedChange={toggle} className="ml-auto" /> : <span className="ml-auto text-slate-400">{zh ? "仅管理员可改" : "admin only"}</span>}
      {s.updatedAt && <span className="text-slate-400 w-full">{zh ? "最近修改" : "Updated"}: {s.updatedBy || "—"} · {String(s.updatedAt).slice(0, 16).replace("T", " ")}</span>}
    </div>
  );
}
